import { Printer } from "lucide-react";
import { Link } from "react-router-dom";
import { useApi, fmtDate } from "../lib/api";
import { DgcEmblem } from "../components/Logo";

export default function Report() {
  const { data: r, error } = useApi("/exec/reports/latest");
  if (error) return (
    <div className="p-10" data-testid="report-empty">
      <p className="text-slate-400">{error}</p>
      <Link to="/app/exec" className="btn-gold mt-4" data-testid="report-go-exec">Go to Executive Intelligence → “Give me today's summary”</Link>
    </div>
  );
  if (!r) return <div className="p-10 font-data text-xs text-slate-500">Loading report…</div>;
  const s = r.overview.sentiment;
  return (
    <div className="p-5 md:p-10" data-testid="daily-report">
      <div className="flex justify-end gap-2 mb-4 no-print">
        <button onClick={() => window.print()} className="btn-gold" data-testid="executive-pdf-download-btn"><Printer size={14} /> Download PDF</button>
      </div>
      <article className="print-sheet panel max-w-3xl mx-auto p-8 md:p-12">
        <header className="flex items-center justify-between border-b border-[color:var(--line)] pb-6 mb-6">
          <div className="flex items-center gap-4"><DgcEmblem size={56} /><div><div className="font-display text-xl text-gold">DGC Daily Intelligence</div><div className="font-data text-[10px] text-slate-500 uppercase tracking-widest">For Dr. Osei Kwame Despite & Dr. Ernest Ofori Sarpong</div></div></div>
          <div className="text-right font-data text-xs text-slate-400">{fmtDate(r.created_at)}<div>by {r.generated_by}</div></div>
        </header>
        <div className="grid grid-cols-4 gap-3 mb-6 font-data text-center">
          <div><div className="text-2xl text-ink">{s.index}</div><div className="text-[9px] text-slate-500">SENTIMENT</div></div>
          <div><div className="text-2xl text-ink">{r.overview.alerts.length}</div><div className="text-[9px] text-slate-500">ALERTS</div></div>
          <div><div className="text-2xl text-ink">{r.overview.staff.total}</div><div className="text-[9px] text-slate-500">STAFF</div></div>
          <div><div className="text-2xl text-ink">{r.overview.recruitment.applications}</div><div className="text-[9px] text-slate-500">APPLICATIONS</div></div>
        </div>
        <div className="whitespace-pre-line text-sm leading-relaxed text-slate-200" data-testid="report-text">{r.text}</div>
        <footer className="mt-8 pt-4 border-t border-[color:var(--line)] text-[10px] text-slate-500 font-data">
          Sources: Peacefmonline.com public articles (scraped {fmtDate(r.overview.scrape?.last_run)}); DGC Operations Hub. Narrative by Claude Sonnet 4.5 from listed facts only. {r.facts.data_caveat}
        </footer>
      </article>
    </div>
  );
}
